var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckOutDisabled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M.825 7.01 1.862 8h.543l-.518 3.012c-.087.508.229.928.717.982l.108.006h8.58c.54 0 .917-.442.824-.988L11.597 8h.577l1.01-.98c.192.287.32.616.36.968l.446 4.024C14.112 13.11 13.31 14 12.206 14H1.796C.69 14-.11 13.113.012 12.012L.46 7.988C.5 7.633.63 7.3.825 7.01M9.585 0l1.55 1.5L8.553 4l2.584 2.5L9.586 8 7 5.5 4.417 8l-1.55-1.5L5.45 4 2.867 1.5 4.417 0l2.584 2.5z"
})));
export default SvgCheckOutDisabled;